import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { ConfigApiConstant } from '../../constants/parmed-api.constant';
import { PublisherService } from '../publisher.service';
import { AppEnv, CacheConstant } from '../../constants/app.constant';
import { AppUtilService } from '../../utils/app-util.service';
import { AppConfig } from '../../../shared/models/app';
import { HttpHeaders } from '@angular/common/http';
import { AppCacheService } from '../cache/app-cache.service';
import { BehaviorSubject } from 'rxjs';
import { SanitizerService } from '../sanitizer.service';

export enum Configuration {
  BUID = 'buId',
  API_KEY = 'apiKey',
  UNDER_MAITENANCE = 'appDown',
  USER_API_ENDPOINT = 'userApiEndpoint',
  CONFIG_API_ENDPOINT = 'configApiEndpoint',
  ORDER_API_ENDPOINT = 'orderApiEndPoint',
  AUTH_API_ENDPOINT = 'authApiEndPoint',
  LOGIN_API_ENDPOINT = 'loginApiEndPoint',
  EXP_API_ENDPOINT = 'expApiEndPoint',
  PRODUCT_API_ENDPOINT = 'productApiEndPoint',
  CMS_API_ENDPOINT = 'cmsUrlEndPoint',
  PARMED_THEME = 'theme',
  AXWAY_API_URL = 'axWayApiUrl',
  // AEM_API_URL = 'aemUrl',
  IMAGE_BASE_URL = 'imageBaseUrl'
}

@Injectable()
export class AppConfigService {
  /*********************Properties*********************/
  private config: AppConfig = null;
  // private configBaseUrl =
  //   environment.name === AppEnv.Local
  //     ? environment.configBaseUrl
  //     : AppUtilService.getBaseUrl();
  private configBaseUrl = '';
  // flag = environment.name.includes(AppEnv.Local);
  configLoaded = false;
  gTrackingId: string;
  gtmContainerId: string;
  webSEODescription: string;
  webSEOKeywords: string;
  webSEORobots: string;
  isConfigLoaded = new BehaviorSubject<boolean>(false);
  isSerializationOn: boolean;
  isDscsaReturnMockDataFlagOn: boolean;
  lookerReportEffectiveDate: string;
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    private http: HttpService,
    private appCacheService: AppCacheService,
    private sanitizerService: SanitizerService
  ) {
    // commented to remove java dependency from code
    // if(this.flag){
    // this.configBaseUrl =  environment.configBaseUrl;
    // }
    // else{
    //   this.configBaseUrl =  AppUtilService.getBaseUrl();
    // }
    // this.configBaseUrl = environment.configBaseUrl;
  }
  /*********************Constructor*********************/

  /*********************Service Methods*********************/

  get(key: Configuration): string {
    let value = '';

    if (this.config && this.config[key] !== undefined) {
      value = this.config[key];
    }

    return value.toString();
  }

  private createRequestOptions() {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      //API key for first call is passed through nginx header
      //"x-api-key": "DGewoHPEhrSPOKSfpC8E7OAT2GY8LtjV"
      
    });
    return headers;
  }
  load() {
    let option = this.createRequestOptions();
    
    return new Promise((resolve, reject) => {

      this.http
        .get(
          '/setting',
          { headers: option }
        )
        .subscribe((configResponse: any) => {
          this.config = {
            buId: configResponse.buId,
            apiKey: configResponse.propertiesVO.apiKey,
            userApiEndpoint: configResponse.propertiesVO.userBaseUrl,
            configApiEndpoint: configResponse.propertiesVO.configBaseUrl,
            orderApiEndPoint: configResponse.propertiesVO.orderBaseUrl,
            authApiEndPoint: configResponse.propertiesVO.authBaseUrl,
            productApiEndPoint: configResponse.propertiesVO.productBaseUrl,
            loginApiEndPoint: configResponse.propertiesVO.loginBaseUrl,
            appDown: configResponse.propertiesVO.appDown,
            theme: 'parmed-theme',
            axWayApiUrl: configResponse.environmentVO.axWayApiUrl,
            expApiEndPoint: configResponse.propertiesVO.experienceBaseUrl,
            cmsUrlEndPoint: configResponse.environmentVO.cmsUrl,
            cmsPageConfigVO: configResponse.environmentVO.cmsPageConfigVO,
            imageBaseUrl: configResponse.environmentVO.imageBaseUrl
          };
          this.isSerializationOn = configResponse.environmentVO.isSerializationOn;
          this.isDscsaReturnMockDataFlagOn = configResponse.environmentVO.dscsaReturnMockDataFlag;
          this.lookerReportEffectiveDate = configResponse.environmentVO.lookerReportEffectiveDate;
          this.gTrackingId = configResponse.environmentVO.gtagId;
          this.gtmContainerId = configResponse.environmentVO.gtmContainerId;
          this.webSEODescription = configResponse.environmentVO.webSEO.description;
          this.webSEOKeywords = configResponse.environmentVO.webSEO.keywords;
          this.webSEORobots = configResponse.environmentVO.webSEO.robots;
          this.appCacheService.set(CacheConstant.Env_Properties, 
            configResponse.environmentVO, Number.MAX_VALUE);
          this.isConfigLoaded.next(true);
          PublisherService.notifyConfig(true);
          this.configLoaded = true;
          resolve(true);
        });
    });
  }

  loadMobileApp() { }

  getStaticData() {
    const sanitizedUrl = this.sanitizerService.sanitizeUrl(
      this.config.configApiEndpoint + ConfigApiConstant.GET_STATIC_DATA
    );
    return this.http.post(
        sanitizedUrl,
        {
          appTypeCodes: [0],
          buId: this.appCacheService.get(CacheConstant.Env_Properties).buId
        },
        AppUtilService.getHttpDefaultOptions()
      )
      .map((staticResponse: any) => {
        if (!staticResponse.hasError) {
          AppUtilService.cache.set(
            CacheConstant.Static_Data,
            staticResponse,
            Number.MAX_VALUE
          );
          PublisherService.notifyStaticDataLoaded(staticResponse);
        }
      });
  }
  
  /*********************Service Methods*********************/
  
}
